import {splitByUpperCase} from '@/utils/helpers';
import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FarmService} from '@services/farm.service';
import {LoaderService} from '@services/loader.service';
import {MedicationService} from '@services/medication.service';
import {VaccineService} from '@services/vaccine.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-edit-vaccine',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule],
    templateUrl: './edit-vaccine.component.html',
    styleUrl: './edit-vaccine.component.scss'
})
export class EditVaccineComponent implements OnInit {
    public vaccineId: number;

    public vaccineForm: FormGroup;
    public currentDate: string;
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;

    public hatcheryVaccination: any = [];
    public suppliers: any[] = [];
    public applications: any[] = [];
    public classifications: any[] = [];
    public farmlist: any[] = [];
    public UserDetail: any;
    public splitByUpperCase = splitByUpperCase;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private vaccineService: VaccineService,
        private medicationService: MedicationService,
        private farmService: FarmService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.vaccineId = this.route.snapshot.params['id'];
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        const today = new Date();
        this.currentDate = today.toISOString().split('T')[0];
        this.vaccineForm = this.fb.group({
            brand: ['', Validators.required],
            arabicBrandName: ['', Validators.pattern(/^[\u0600-\u06FF0-9-\s]+$/)],
            supplierTypeId: ['', Validators.required],
            expireDate: ['', [Validators.required]],
            batchNumber: ['', Validators.required],
            vaccineTypeId: ['', Validators.required],
            sku: [''],
            qty: ['', [Validators.required, Validators.min(0)]],
            applicationId: ['', Validators.required],
            hatcheryTypeId: ['', Validators.required],
            farmId: ['', Validators.required],
            chickAgeFrom: ['', [Validators.required, Validators.min(0)]],
            chickAgeTo: ['', [Validators.required, Validators.min(0)]],
            lowStockLevel: ['', Validators.required]
        });

        this.getSupplierTypeList();
        this.getApplicationTypeList();
        this.getClassificationTypeList();
        this.getHatcheryVaccinationList();
        this.getFarmList(this.UserDetail.id);

        if (this.vaccineId) {
            this.GetVaccineDetailsById(this.vaccineId);
        }
    }

    GetVaccineDetailsById(VaccineId: number) {
        this.vaccineService
            .getVaccineDetailsById(VaccineId)
            .subscribe((response: any) => {
                if (response.expireDate) {
                    const dateObj = new Date(response.expireDate);
                    const formattedDate = dateObj.toISOString().split('T')[0];
                    response.expireDate = formattedDate;
                }

                this.vaccineForm.patchValue(response);
                // this.onVaccineTypeChange(response.vaccineTypeId, false);
            });
    }

    getSupplierTypeList() {
        this.medicationService.getSuppierList().subscribe((result) => {
            this.suppliers = result;
        });
    }

    getApplicationTypeList() {
        this.medicationService.getApplicationTypeList().subscribe((result) => {
            this.applications = result;
        });
    }

    getClassificationTypeList() {
        this.medicationService.getClassificationList().subscribe((result) => {
            this.classifications = result;
        });
    }

    getHatcheryVaccinationList() {
        this.vaccineService.getVaccinationList().subscribe((result: any) => {
            this.hatcheryVaccination = result;
        });
    }

    getFarmList(userId: number) {
        this.farmService.getFarmList(userId).subscribe((result) => {
            this.farmlist = result;
        });
    }

    triggerDatePicker(event: any): void {
        const dateInput = event.target;
        dateInput.focus();
        dateInput.click();
    }

    onSubmit() {
        this.loaderService.showLoader();
        this.isAuthLoading = true;

        if (!this.vaccineForm.valid) {
            this.loaderService.hideLoader();
            this.vaccineForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
            return;
        }

        const vaccineData = {
            ...this.vaccineForm.value,
            id: this.vaccineId
        };

        this.vaccineService.updateVaccineDetail(vaccineData).subscribe({
            next: (response) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.success('Vaccine detail Updated Successfully');
                }, 2000);
                this.router.navigate(['/vaccine-list']);
            },
            error: (error) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.error(error.error);
                }, 2000);
            }
        });
    }
    onClose(): void {
        this.router.navigate(['/vaccine-list']);
    }
}
